import { useState, useEffect, useRef } from "react";
import PublicNav from "../components/public/PublicNav";
import PublicFooter from "../components/public/PublicFooter";
import "./Landing.css";

export default function Landing() {
  // Word-by-word animation for workflow text
// Word-by-word animation for workflow text (FIXED VERSION)
useEffect(() => {
  const steps = document.querySelectorAll(".workflow__step");
  if (!steps.length) return;

  let currentStep = 0;
  let currentTimeout;
  let isTyping = true; // IMPORTANT FLAG

  // reset everything
  steps.forEach(step => {
    const textEl = step.querySelector(".workflow__text");
    if (textEl) textEl.textContent = "";
    step.classList.remove("active");
  });

  function typeStep() {
    if (currentStep >= steps.length) {
      isTyping = false; // typing finished
      enableHover();
      return;
    }

    const step = steps[currentStep];
    const textEl = step.querySelector(".workflow__text");
    const fullText = textEl.dataset.text;

    step.classList.add("active");

    let charIndex = 0;

    function typeLetter() {
      if (charIndex <= fullText.length) {
        textEl.textContent = fullText.slice(0, charIndex);
        charIndex++;
        currentTimeout = setTimeout(typeLetter, 25);
      } else {
        step.classList.remove("active");
        currentStep++;
        currentTimeout = setTimeout(typeStep, 400);
      }
    }

    typeLetter();
  }

  function enableHover() {
    steps.forEach(step => {
      const textEl = step.querySelector(".workflow__text");

      step.addEventListener("mouseenter", () => {
        if (isTyping) return;
        textEl.textContent = textEl.dataset.hover;
      });

      step.addEventListener("mouseleave", () => {
        if (isTyping) return;
        textEl.textContent = textEl.dataset.text;
      });
    });
  }

  typeStep();

  return () => clearTimeout(currentTimeout);

}, []);
const fullText = "Generate your beautiful greeting cards just in seconds.";
const [displayText, setDisplayText] = useState("");
const [startTyping, setStartTyping] = useState(false);
const ctaRef = useRef(null);
const [ctaVisible, setCtaVisible] = useState(false);
const heroCardRef = useRef(null);
const [heroCardVisible, setHeroCardVisible] = useState(false);
const trustRef = useRef(null);
const [trustVisible, setTrustVisible] = useState(false);
useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setCtaVisible(true);
      }
    },
    { threshold: 0.3 }
  );

  if (ctaRef.current) {
    observer.observe(ctaRef.current);
  }

  return () => observer.disconnect();
}, []);
useEffect(() => {
  // Wait for images animation to complete
  const timer = setTimeout(() => {
    setStartTyping(true);
  }, 3000);   // 👈 adjust to match image animation time

  return () => clearTimeout(timer);
}, []);

useEffect(() => {
  if (!startTyping) return;

  let i = 0;
  const interval = setInterval(() => {
    setDisplayText(fullText.slice(0, i + 1));
    i++;
    if (i === fullText.length) clearInterval(interval);
  }, 50);

  return () => clearInterval(interval);
}, [startTyping]);
 useEffect(() => {
    const items = document.querySelectorAll(".timeline__item");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.3 }
    );

    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
  const steps = document.querySelectorAll(".workflow__step");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
        }
      });
    },
    {
      threshold: 0.25
    }
  );

  steps.forEach((step) => observer.observe(step));

  return () => observer.disconnect();
}, []);
 
useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setHeroCardVisible(true);
      }
    },
    { threshold: 0.4 }
  );

  if (heroCardRef.current) {
    observer.observe(heroCardRef.current);
  }

  return () => observer.disconnect();
}, []);

useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setTrustVisible(true);
      }
    },
    { threshold: 0.3 }
  );

  if (trustRef.current) {
    observer.observe(trustRef.current);
  }

  return () => observer.disconnect();
}, []);

  return (
    <div className="landing">
      <PublicNav />
      

      <main>
        <section className="hero">
  <div className="hero__bg">
    <div className="hero__blob hero__blob--tr" />
    <div className="hero__blob hero__blob--bl" />
    <div className="hero__blob hero__blob--center" />
    <div className="hero__dot hero__dot--a" />
    <div className="hero__dot hero__dot--b" />
    <div className="hero__dot hero__dot--c" />
  </div>

  <div className="hero__inner">

    {/* LEFT SIDE */}
    <div className="hero__content">
      <div className="hero__badge">
        <span className="hero__badgeIcon" aria-hidden="true">✦</span>
        <span className="hero__badgeText">
          The Voice of Gifting · AI Greetings MVP
        </span>
      </div>

      <h1 className="hero__title">
        Thoughtful moments,
        <br />
        <span className="hero__titleAccent font-serif">at scale</span>
      </h1>

      <p className="hero__subtitle">
        Zyft started as a voice-powered gifting assistant and is now focused on
        automated emotional touchpoints for teams—personalized birthday and
        festival greetings with your brand voice.
      </p>

      <div className="hero__cta">
        <a
          className="hero__primaryBtn"
          href="mailto:sales@zyft.ai?subject=Zyft%20Demo%20Request"
        >
          Request Demo →
        </a>
        <a className="hero__secondaryBtn" href="#features">
          View Platform
        </a>
      </div>
    </div>

    {/* RIGHT SIDE */}
    <div className="hero__right">

      {/* Animated Greeting Card */}
      <div className="cardContainer">
        <img src="/images/card.jpg" alt="Birthday Card" className="cardImage" />
        <img src="/images/butterfly.gif" alt="" className="butterfly b1" />
        <img src="/images/butterfly.gif" alt="" className="butterfly b2" />

        <div className="cardText">
          {displayText}
        </div>
      </div>

    </div>
  </div>
</section>
 <div
  ref={heroCardRef}
  className={`hero__card ${heroCardVisible ? "hero__cardExpand" : "hero__cardCompressed"}`}
>
        <div className="hero__cardGlow" />
        <div className="hero__cardBody">
          <div className="hero__arch">
            <div className="hero__archTop" />
            <div className="hero__archInner">
              <span className="hero__archKicker">AI Greeting Cards</span>
              <p className="hero__archDesc">
                Automated, branded, and emotionally aligned
              </p>
              <a className="hero__archLink" href="#features">
                Explore →
              </a>
            </div>
          </div>
        </div>
      </div>
       <section
  ref={trustRef}
  className={`trust ${trustVisible ? "trust--active" : ""}`}
>
  <div className="trust__inner">
    <p className="trust__label">Integrations & roadmap</p>

    <div className="trust__logos">
      {[
        ["Resend", "Live", "/images/resend-icon.png"],
        ["SMTP", "Live", "/images/smtp-icon.png"],
        ["Shopify", "Planned", "/images/shopify-icon.png"],
        ["Amazon", "Planned", "/images/amazon-icon.png"],
        ["Etsy", "Planned", "/images/etsy-icon.png"],
        ["Instagram Shops", "Planned", "/images/instagram-icon.png"],
      ].map(([name, status, logo]) => (
        <div key={name} className="trust__logo">

          <img
            src={logo}
            alt={name}
            className="trust__logoImg"
          />

          <div className="trust__logoName">
            {name}
            <span
              className={`trust__pill ${
                status === "Live" ? "is-live" : "is-planned"
              }`}
            >
              {status}
            </span>
          </div>

        </div>
      ))}
    </div>
  </div>
</section>

        <section id="features" className="features">
          <div className="features__inner">
            <div className="features__header">
              <span className="features__kicker">Current MVP</span>
              <h2 className="features__title">
                AI Greetings, built for{" "}
                <span className="features__titleAccent font-serif">real teams</span>
              </h2>
              <p className="features__subtitle">
                Deliver personalized birthday and festival greetings at scale—copy + imagery,
                review & regenerate, then one-click send.
              </p>
            </div>

           <div className="timeline">

  {[
    [
      "Employee Management Layer",
      "Add employees with name, email, DOB, department, and interests. Zyft highlights today's birthdays and upcoming events."
    ],
    [
      "Occasion Engine",
      "Select an occasion (Diwali, Christmas, New Year, Eid) and generate themed greetings consistently across the company."
    ],
    [
      "AI Content Generator",
      "AI generates a card image + personalized message based on interests and context—then you can regenerate in seconds."
    ],
    [
      "Greeting Customization Panel",
      "Review, edit, and fine-tune tone/branding before sending. Keep quality high without design effort."
    ],
    [
      "Email Delivery Pipeline",
      "One-click email delivery via Resend or SMTP with a clean template (HTML + text) for better inbox placement."
    ],
    [
      "Roadmap: Voice + Emotion Intent",
      "Voice/text gift requests with emotion + intent understanding (planned). Marketplace aggregation (Amazon/Shopify APIs) is next."
    ]
  ].map(([title, desc], i) => (
    <div className="timeline__item" key={title}>
      <div className="timeline__line"/>
      <div className="timeline__card">
        <div className="timeline__number">{i + 1}</div>
        <div className="timeline__content">
          <h3>{title}</h3>
          <p>{desc}</p>
        </div>
      </div>
    </div>
  ))}
</div>
            
             {/* Workflow Section */}
            <div className="workflow">
              <div className="workflow__header">
                <span className="workflow__kicker">MVP workflow</span>
                <h3 className="workflow__title">From employee list → sent greeting</h3>
              </div>

               <div className="workflow__stepsWrapper">
  <ul className="workflow__steps">

    {/* Step 1 */}
    <li className="workflow__step">
      <img src="/images/step1.gif" alt="Step 1" className="workflow__stepGif" />
      <img src="/images/chatbot.gif" alt="Chatbot" className="workflow__chatbotGif" />
      <span
        className="workflow__text"
        data-text="Add employees with name, email, DOB, department, and interests."
        data-hover="Hi! I'm Zyft 👋 Add your employees, and I’ll remember everything important about them for you."
      ></span>
    </li>

    {/* Step 2 */}
    <li className="workflow__step">
      <img src="/images/step2.gif" alt="Step 2" className="workflow__stepGif" />
      <img src="/images/chatbot.gif" alt="Chatbot" className="workflow__chatbotGif" />
      <span
        className="workflow__text"
        data-text="Zyft highlights today’s birthdays and upcoming milestones."
        data-hover="Did u miss some special day? its ok you focus on your work ill remember the moments."
      ></span>
    </li>

    {/* Step 3 */}
    <li className="workflow__step">
      <div className="workflow__stepGrid">
        <img src="/images/step3.gif" alt="Step 3.1" />
        <img src="/images/step3.1.gif" alt="Step 3.2" />
        <img src="/images/step3.2.gif" alt="Step 3.3" />
        <img src="/images/step3.3.gif" alt="Step 3.4" />
      </div>
      <img
    src="/images/chatbot.gif"
    alt="Chatbot"
    className="workflow__chatbotGif"
  />
      <span
        className="workflow__text"
        data-text="Pick an occasion (birthday, Diwali, Christmas, New Year, Eid)."
        data-hover="Choose your ocassion then, I'll create something magical✨."
      ></span>
    </li>

    {/* Step 4 */}
    <li className="workflow__step">
      <img src="/images/step4.gif" alt="Step 4" className="workflow__stepGif" />
      <img src="/images/chatbot.gif" alt="Chatbot" className="workflow__chatbotGif" />
      <span
        className="workflow__text"
        data-text="AI generates a themed image + personalized message."
        data-hover="Give me a second. I’m creating something beautiful✨."
      ></span>
    </li>

    {/* Step 5 */}
    <li className="workflow__step">
      <img src="/images/step5.gif" alt="Step 5" className="workflow__stepGif" />
      <img src="/images/chatbot.gif" alt="Chatbot" className="workflow__chatbotGif" />
      <span
        className="workflow__text"
        data-text="Review, customize, and regenerate if needed."
        data-hover="Didnt like it ? Come let's customize it together🎨."
      ></span>
    </li>

    {/* Step 6 */}
    <li className="workflow__step">
      <img src="/images/step6.gif" alt="Step 6" className="workflow__stepGif" />
      <img src="/images/chatbot.gif" alt="Chatbot" className="workflow__chatbotGif" />
      <span
        className="workflow__text"
        data-text="Send with one click via Resend or SMTP."
        data-hover="All set! Just one click and I’ll deliver your message instantly."
      ></span>
    </li>

  </ul>
</div>
            </div>
          </div>
        </section>


        <section ref={ctaRef} className={`cta ${ctaVisible ? "cta--visible" : ""}`}>
          <div className="cta__bg">
            <div className="cta__blob cta__blob--tr" />
            <div className="cta__blob cta__blob--bl" />
          </div>

          <div className="cta__inner">
            <span className="cta__kicker">Get Started Today</span>
            <h2 className="cta__title">
              Ready to scale
              <br />
              <span className="cta__accent font-serif">employee engagement?</span>
            </h2>
            <p className="cta__subtitle">
              Join forward-thinking companies using Zyft to automate recognition and
              build culture at scale with complete data privacy and control.
            </p>

            <div className="cta__buttons">
              <a
                className="cta__primary"
                href="mailto:sales@zyft.ai?subject=Zyft%20Enterprise%20Demo"
              >
                Request Enterprise Demo <span aria-hidden="true">→</span>
              </a>
              <a className="cta__secondary" href="mailto:sales@zyft.ai?subject=Talk%20to%20Sales">
                Talk to Sales
              </a>
            </div>

            <p className="cta__footnote">
              Enterprise-grade security · Dedicated support · Custom implementation
            </p>
          </div>
        </section>
      </main>

      <PublicFooter />
    </div>
  );
}

